import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getUserLanguage } from './userLanguage'
import german from './phrase/german.json'
import english from './phrase/english.json'
import french from './phrase/french.json'
import italian from './phrase/italian.json'

i18next
	.use(initReactI18next)
	.init({
		lng: getUserLanguage() || 'German',
		debug: false,
		fallbackLng: process.env.NODE_ENV === 'production' ? 'German' : null,
		resources: {
			German: { translation: german },
			English: { translation: english },
			French: { translation: french },
			Italian: { translation: italian }
		},
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		}
	})
